import { Link } from 'react-router-dom';

import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Box, MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTheme } from '@mui/material/styles';

import { AppRoute } from 'share/types/routes';
import { formatDateWithDashes, formatEpochDate } from 'utils';

import { OrdersAndExpenseType } from './types';

import './styles.scss';

export const OrdersAndExpense = ({
  ordersStatsData,
  setDatePeriod,
  datePeriod,
  currency
}: OrdersAndExpenseType) => {
  const theme = useTheme();
  const interactionPrimary = theme.palette.interaction.primary;
  const currentDate = new Date();
  const handleChange = (value: string) => {
    setDatePeriod(value);
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <Typography type="title-md" marginBottom="sm">
          Orders & expenses
        </Typography>
        <Link
          style={{
            fontWeight: 600,
            fontSize: 14,
            width: 'unset',
            cursor: 'pointer',
            color: interactionPrimary,
            textDecoration: 'none'
          }}
          to={AppRoute.Report}
        >
          See reports
        </Link>
      </Box>
      <Box sx={{ marginRight: 'auto' }}>
        <Select
          name="date"
          id="date"
          displayEmpty
          value={datePeriod}
          onChange={(e: SelectChangeEvent) =>
            handleChange(e.target.value as string)
          }
          inputProps={{
            sx: {
              px: 0,
              py: 1.3
            }
          }}
          sx={{
            marginBottom: '18px',
            marginTop: '8px',
            '.MuiOutlinedInput-notchedOutline': {
              border: 0,
              borderColor: 'transparent !important'
            }
          }}
        >
          <MenuItem value="0">
            Week to date,{' '}
            {formatEpochDate(new Date().setDate(currentDate.getDate() - 7))} -{' '}
            {formatEpochDate(new Date().setDate(currentDate.getDate()))}
          </MenuItem>
          <MenuItem value="1">
            Last 30 days,{' '}
            {formatEpochDate(new Date().setDate(currentDate.getDate() - 30))} -{' '}
            {formatEpochDate(new Date().setDate(currentDate.getDate()))}
          </MenuItem>
          <MenuItem value="2">
            Last month,{' '}
            {formatDateWithDashes(
              new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1)
            )}{' '}
            -{' '}
            {formatDateWithDashes(
              new Date(currentDate.getFullYear(), currentDate.getMonth(), 0)
            )}
          </MenuItem>
        </Select>
      </Box>
      <div className="orders-expense-container__content">
        <Typography type="label-lg">Total Orders</Typography>
        <Typography type="label-lg">{ordersStatsData?.total_order}</Typography>
      </div>
      <div className="orders-expense-container__content">
        <Typography type="label-lg">Total Expense</Typography>
        <Typography type="label-lg">
          {currency} {ordersStatsData?.total_expense}
        </Typography>
      </div>
      <div className="orders-expense-container__content">
        <Typography type="label-lg">Average Order Expense</Typography>
        <Typography type="label-lg">
          {currency} {ordersStatsData?.avg_order_expense}
        </Typography>
      </div>
    </>
  );
};
